import React from 'react';

type ResizeTableContextType = {
  isResizing: boolean;
  setIsResizing: React.Dispatch<React.SetStateAction<boolean>>;
};

const ResizeTableContext = React.createContext<ResizeTableContextType>(
  {} as ResizeTableContextType
);

export const useResizeTable = () => React.useContext(ResizeTableContext);

export const ResizeTableProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [isResizing, setIsResizing] = React.useState(false);

  return (
    <ResizeTableContext.Provider value={{ isResizing, setIsResizing }}>
      {children}
    </ResizeTableContext.Provider>
  );
};
